module.exports = __webpack_public_path__ + "static/media/icon-loc.e6271a14.svg";